import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Sidebar, BottomNav } from './Navigation';
import { Loader2, LogOut } from 'lucide-react';

const Layout = () => {
  const { user, loading, logout } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="flex flex-col items-center gap-4">
          <Loader2 className="w-10 h-10 text-neon-pink animate-spin" />
          <p className="text-gray-500 font-medium">Chargement...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="flex min-h-screen bg-white">
      <Sidebar />
      <main className="flex-1 pb-24 md:pb-0 overflow-x-hidden min-w-0 relative">
        <button
          onClick={logout}
          data-testid="mobile-logout-btn"
          className="md:hidden fixed top-3 right-3 z-50 w-9 h-9 rounded-full bg-white/90 border border-gray-200 flex items-center justify-center text-gray-500 hover:text-red-600 hover:border-red-500/30 transition-colors backdrop-blur-sm"
          aria-label="Déconnexion"
        >
          <LogOut size={16} />
        </button>
        <Outlet />
      </main>
      <BottomNav />
    </div>
  );
};

export default Layout;
